import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/cdc-market/cdc-market/src/app/error.tsx");
